import angular from 'angular';

(function () {
    'use strict';

    angular.module('app.link_request', []);
})();
